(() => {
  if (window.b2bInquiryInstalled) return;
  window.b2bInquiryInstalled = true;
  const instances = new WeakMap();
  const init = (root) => {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const gallery = root.querySelector('[data-gallery]');
    const selectMedia = (id, focus = false) => {
      if (!gallery || !id || !gallery.querySelector(`[data-media-id="${CSS.escape(String(id))}"]`)) return;
      gallery.querySelectorAll('[data-media-id]').forEach((item) => {
        const wasVisible = !item.hidden;
        item.hidden = item.dataset.mediaId !== String(id);
        item.classList.toggle('is-active', !item.hidden);
        if (item.hidden && wasVisible) {
          item.querySelectorAll('video').forEach((video) => video.pause());
          item.querySelectorAll('iframe').forEach((frame) => { const source = frame.getAttribute('src'); if (source) frame.setAttribute('src', source); });
          item.querySelectorAll('model-viewer').forEach((model) => { model.pause?.(); model.modelViewerUI?.pause?.(); });
        }
      });
      gallery.querySelectorAll('[data-media-target]').forEach((button) => { const active = button.dataset.mediaTarget === String(id); button.classList.toggle('is-active', active); button.setAttribute('aria-current', String(active)); if (active && focus) button.focus(); });
    };
    gallery?.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-media-target]');
      if (thumb) selectMedia(thumb.dataset.mediaTarget);
      const open = event.target.closest('[data-dialog-open]');
      if (open) { const dialog = root.querySelector(`#${CSS.escape(open.dataset.dialogOpen)}`); const image = dialog?.querySelector('[data-dialog-image]'); if (dialog && image) { image.src = open.dataset.zoomSrc; image.alt = open.dataset.zoomAlt; dialog.showModal(); dialog.addEventListener('close', () => open.focus(), { once: true, signal }); } }
      if (event.target.closest('[data-dialog-close]')) event.target.closest('dialog')?.close();
    }, { signal });
    root.querySelectorAll('[data-media-dialog]').forEach((dialog) => dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); }, { signal }));
    const variantSelect = root.querySelector('[data-variant-select]');
    variantSelect?.addEventListener('change', () => { const option = variantSelect.selectedOptions[0]; const featuredMediaId = option.dataset.featuredMediaId; if (featuredMediaId) selectMedia(featuredMediaId); }, { signal });
    if (root.querySelector('model-viewer') && window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: (errors) => {
        if (errors || signal.aborted) return;
        root.querySelectorAll('model-viewer').forEach((model) => {
          if (!model.modelViewerUI) model.modelViewerUI = new window.Shopify.ModelViewerUI(model);
        });
      } }]);
    }
    instances.set(root, controller);
  };
  const destroy = (root) => { instances.get(root)?.abort(); instances.delete(root); };
  document.querySelectorAll('[data-b2b-inquiry-section]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-b2b-inquiry-section]').forEach(init));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-b2b-inquiry-section]').forEach(destroy));
})();
